import { useTranslation } from "react-i18next";
import { Button, Flex } from "antd";

import AuthCard from "../../components/auth/AuthCard";
import { usePageTitle } from "../../utils/usePageTitle";

export const ExistingGoogleEmailPage = () => {
  const { t } = useTranslation();
  usePageTitle(t("existingGoogleEmail.title"));

  return (
    <AuthCard>
      <h1>{t("existingGoogleEmail.title")}</h1>
      <p>{t("existingGoogleEmail.description")}</p>
      <Flex gap={8} style={{ marginTop: 8 }} wrap>
        <Button type="primary" size="large" href="/login/1">
          {t("signin.buttonText")}
        </Button>
        <Button size="large" href="/google/login/">
          {t("existingGoogleEmail.chooseAnother")}
        </Button>
      </Flex>
    </AuthCard>
  );
};
